module.exports = __webpack_public_path__ + "img/IND-A-3-III.6dfdbf44.png";